import React from 'react';
import Brand from '../Layout/Brand';
import SeoHead from './SeoHead';
import '../../styles/marketing.css';

export default function SupportPage() {
  return (
    <div className="legal-site">
      <SeoHead
        title="LeaveNOW Support"
        description="Get help with LeaveNOW trips, alerts, subscriptions, privacy, and account access."
        path="/support"
      />
      <header className="checkout-header"><a href="/" aria-label="LeaveNOW home"><Brand /></a><a href="/">Back to LeaveNOW</a></header>
      <main>
        <p className="marketing-eyebrow">Support</p>
        <h1>We’ll help you get moving.</h1>
        <p>For trip, alert, subscription, or account help, email <a href="mailto:support@getleavenow.com">support@getleavenow.com</a>.</p>

        <h2>Include these details</h2>
        <p>Tell us your iPhone model, iOS version, LeaveNOW build number, what you expected, and what happened. A screenshot is helpful, but remove personal addresses and account information first.</p>

        <h2>Subscriptions</h2>
        <p>You can restore purchases from <strong>Your Plan</strong> in LeaveNOW. Manage or cancel an App Store subscription from <a href="https://apps.apple.com/account/subscriptions">Apple Subscriptions</a>. Canceling does not delete your account or trip history.</p>

        <h2>Permissions</h2>
        <p>LeaveNOW needs notification and location access for departure alerts and active-trip monitoring. If a feature is unavailable, open iPhone Settings, select LeaveNOW, and review Location, Notifications, and Live Activities.</p>

        <h2>Privacy and account deletion</h2>
        <p>Read the <a href="/privacy">Privacy Policy</a>. You can permanently delete your LeaveNOW account from <strong>Profile → Privacy &amp; Account</strong> in the app.</p>

        <h2>Safety</h2>
        <p>Do not operate LeaveNOW while driving. Route data, network conditions, and iOS background delivery can change. Confirm critical travel plans with the relevant navigation or transportation provider.</p>

        <h2>Response time</h2>
        <p>We aim to respond to support requests within two business days.</p>
      </main>
    </div>
  );
}
